import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, ListRow } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  {
    title: 'ASTM E779 Pressurization',
    description: 'Whole-building leakage from a pressurization fan test',
    screen: 'BETPressurization',
  },
  {
    title: 'ASTM E1827 Depressurization',
    description: 'Single-point depressurization leakage at reference ΔP',
    screen: 'BETDepressurization',
  },
  {
    title: 'Multi-Point Regression',
    description: 'Fit flow coefficient C and exponent n across multiple pressures',
    screen: 'BETRegression',
  },
  {
    title: 'Air Leakage Rate',
    description: 'Normalize leakage to CFM75, CFM50, or ACH50',
    screen: 'BETAirLeakageRate',
  },
  {
    title: 'Effective Leakage Area',
    description: 'ELA from leakage flow and reference pressure difference',
    screen: 'BETEffectiveLeakageArea',
  },
  {
    title: 'Air Changes Per Hour',
    description: 'ACH from leakage CFM and building volume',
    screen: 'BETAirChangesPerHour',
  },
];

export default function BETCalculationsScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="BET Calculations" subtitle="Building envelope testing">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c, i) => (
        <ListRow
          key={c.screen}
          index={i}
          label={c.title}
          description={c.description}
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
